import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '@solana/wallet-adapter-react';
import { useCreatorPublishing } from '../hooks/useCreatorPublishing';
import { callDigitalAssets } from '../utils/digitalAssetsClient';
export default function CreatorCollectionManager({ spaceId, compact = false }) {
    const wallet = useWallet();
    const { collections, space, loading, error } = useCreatorPublishing(spaceId);
    const [message, setMessage] = useState('');
    const [busy, setBusy] = useState(false);
    const isOwner = wallet.publicKey?.toBase58?.() === String(spaceId);
    const [cluster, setCluster] = useState('');
    useEffect(() => {
        if (!isOwner) return undefined;
        let active = true;
        callDigitalAssets('getConfiguration').then(value => { if (active) setCluster(value.cluster); })
            .catch(failure => { if (active) setMessage(failure.message); });
        return () => { active = false; };
    }, [isOwner]);
    const available = collections.filter(item => item.cluster === cluster && item.status === 'CONFIRMED');
    if (!spaceId || !isOwner) return null;
    return <div className="creator-collections" style={{ margin: '12px 0' }}>
        <Link className="muulti-button" to="/collection-creation">{!loading && !available.length ? space ? 'Create a collection for this Space' : 'Create a Core Collection' : 'Create another Collection'}</Link>
        {!compact && <><p>{loading || !cluster ? 'Loading collections...' : `${available.length} collection${available.length === 1 ? '' : 's'} for this wallet.`}</p>
            {available.map(item => <div key={item.id} style={{ padding: 8 }}>
                <strong>{item.name}</strong> <small>{item.onChainCollectionAddress}</small>
                {space?.defaultCollectionId === item.id ? <span> - Default collection</span> : space ?
                    <button type="button" className="muulti-button" disabled={busy} onClick={async () => {
                        try { setBusy(true); setMessage(''); await callDigitalAssets('setDefaultCollection', { collectionId: item.id }, wallet); }
                        catch (failure) { setMessage(failure.message); } finally { setBusy(false); }
                    }}>Make default</button> : null}
            </div>)}
        </>}
        {(message || error) && <p role="alert">{message || error}</p>}
    </div>;
}
